"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var sumBy_1 = __importDefault(require("lodash/sumBy"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var BarHor_1 = __importDefault(require("atomicComponents/atoms/Graphs/BarHor"));
var BarHorTitle_1 = __importDefault(require("atomicComponents/organisms/Text/BarHorTitle"));
var Money_1 = __importDefault(require("components/Money"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var Text_1 = __importDefault(require("shared/components/Text"));
var BarContainer_1 = __importDefault(require("../../Savings/styles/BarContainer"));
var selectors_1 = require("../../selectors");
var StatAccordion_1 = __importDefault(require("./StatAccordion"));
var SavingsOpportunities = function (_a) {
    var _b;
    var limit = _a.limit, showOthers = _a.showOthers, totalSaasSpend = _a.totalSaasSpend, showBreakdown = _a.showBreakdown;
    var servicesStats = (0, react_redux_1.useSelector)(selectors_1.selectSlightlyPopulatedServiceStatsWithToolAnalysis);
    if (!(0, react_redux_firebase_1.isLoaded)(servicesStats)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    var totalSavingsOpportunities = (0, sumBy_1.default)(servicesStats, 'toolAnalysis.forecastSavings');
    servicesStats.sort(function (a, b) { return (b.toolAnalysis.forecastSavings || 0) - (a.toolAnalysis.forecastSavings || 0); });
    var others = { count: 0, last12MonthSpend: 0, forecastSavings: 0 };
    var serviceStatsToShow = servicesStats === null || servicesStats === void 0 ? void 0 : servicesStats.filter(function (sS) { return sS.toolAnalysis.forecastSavings; });
    var maxSpend = Math.max.apply(Math, __spreadArray([], __read(serviceStatsToShow.map(function (sS) { return sS.toolAnalysis.activeAnnualSpend || 0; })), false)) || 500000;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, __assign({ width: 168, ml: 2 }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, sx: { fontWeight: 600 } }, { children: "My Stack" })) })), (0, jsx_runtime_1.jsxs)(BarContainer_1.default, __assign({ width: 650 }, { children: [(0, jsx_runtime_1.jsx)(BarHor_1.default, __assign({ width: 650 * ((totalSaasSpend - totalSavingsOpportunities) / totalSaasSpend), size: "large", color: "blue" }, { children: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: totalSaasSpend, isShortened: true }) })), (0, jsx_runtime_1.jsx)(BarHor_1.default, { width: 1300 * (totalSavingsOpportunities / totalSaasSpend), size: "large", color: "blue", opacity: 0.25, roundedCornerRight: true }), (0, jsx_runtime_1.jsx)(BarHorTitle_1.default, { title: "Potential Savings", value: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: totalSavingsOpportunities, isShortened: true }), width: 160 })] }))] })), (_b = serviceStatsToShow === null || serviceStatsToShow === void 0 ? void 0 : serviceStatsToShow.slice(0, limit)) === null || _b === void 0 ? void 0 : _b.map(function (sStat) { return ((0, jsx_runtime_1.jsx)(StatAccordion_1.default, { serviceStat: sStat, showBreakdown: showBreakdown, maxSpend: maxSpend }, sStat.id)); }), showOthers && others.count > 0 && (0, jsx_runtime_1.jsxs)("p", { children: ["+ ", others.count, " more... | ", others.last12MonthSpend, " | ", others.forecastSavings] })] }));
};
exports.default = SavingsOpportunities;
